import { render, staticRenderFns } from "./team.introduction.page.vue?vue&type=template&id=501fecbb&scoped=true&"
import script from "./team.introduction.page.vue?vue&type=script&lang=js&"
export * from "./team.introduction.page.vue?vue&type=script&lang=js&"
import style0 from "./team.introduction.page.vue?vue&type=style&index=0&id=501fecbb&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501fecbb",
  null
  
)

export default component.exports